export default {
  Inappropriate: 0,
  Appropriate: 1,
  Undefined: 2,
};
